import React, { useState, useEffect, useRef } from "react";
import { Badge, Col, Row } from "reactstrap";
import { Formik, Form as FormikForm } from "formik";
import { useDispatch } from "react-redux";
import { adminResendOtp, empVerifyOtp, resendOtp, verifyOtp } from "store/actions";
import { localTimeToUtc } from "common/timeConversions";
import { useHistory } from "react-router-dom";
import { resendCounterTime } from "constants/constants";
import useQuery from "hooks/useQuery";
import FormInput from "component/FormControl/FormInput";
import AppButton from "component/Buttons/AppButton";

const VerificationForm = ({ switchLogin = false, ...props }) => {
  const inputRef = useRef();
  const formikRef = useRef();
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useQuery();
  const isAdmin = switchLogin || params.get("admin") ? true : false;

  const [loginData, setLoginData] = useState({});
  const [resend, setResend] = useState(false);
  const [counter, setCounter] = useState(resendCounterTime);
  const current_date = localTimeToUtc();

  useEffect(() => {
    if (counter <= resendCounterTime && counter > 0) {
      setTimeout(() => setCounter(counter - 1), 1000);
    } else if (counter === 0) {
      setCounter(resendCounterTime);
      setResend(true);
    }
  }, [counter]);

  useEffect(() => {
    if (localStorage.getItem("loginData")) {
      setLoginData(JSON.parse(localStorage.getItem("loginData")));
    }
    inputRef.current?.focus();
  }, [localStorage.getItem("loginData")]);

  const resendMyOtp = () => {
    if (isAdmin) {
      dispatch(
        adminResendOtp({
          manager_id: loginData?.manager_id,
          client_id: loginData?.client_id,
          current_date,
          super_admin_id: loginData?.super_admin_id,
          admin_type: loginData?.admin_type,
        })
      );
    } else {
      dispatch(resendOtp({ current_date, staff_id: loginData?.staff_id }));
    }
    setCounter(resendCounterTime);
    setResend(false);
  };

  const onSuccess = () => {
    if (props?.onSuccess) props.onSuccess();
    formikRef.current?.setSubmitting(false);
  };

  return (
    <div className='my-auto'>
      <div className='text-center'>
        <div className='avatar-md mx-auto'>
          <div className='avatar-title rounded-circle bg-light'>
            <i className='bx bxs-envelope h1 mb-0 text-primary'></i>
          </div>
        </div>
        <div className='p-2 mt-4'>
          <h4>Verify your email</h4>
          <p>
            Please enter the 6 digit code sent
            {loginData?.email_sent_to ? (
              <>
                &nbsp;to&nbsp;
                <span className='font-weight-semibold'>{loginData?.email_sent_to}</span>
              </>
            ) : (
              ""
            )}
          </p>
          <div className='text-start'>
            <Formik
              innerRef={formikRef}
              initialValues={{
                staff_id: JSON.parse(localStorage.getItem("loginData"))?.staff_id || "",
                otp: "",
                current_date: current_date,
              }}
              onSubmit={(values, { setSubmitting }) => {
                dispatch(
                  isAdmin
                    ? verifyOtp(
                        {
                          otp: values.otp,
                          current_date,
                          ...loginData,
                        },
                        onSuccess,
                        () => setSubmitting(false),
                        props.apiHeader,
                        history,
                        dispatch
                      )
                    : empVerifyOtp(values, history)
                );
              }}>
              {({ isSubmitting }) => {
                return (
                  <FormikForm>
                    <Row>
                      <Col md={6} className='my-3 mx-auto'>
                        <FormInput name='otp' inputProps={{ innerRef: inputRef, placeholder: "Enter 6 digit OTP" }} />
                      </Col>
                      <Col md='12' className='text-center'>
                        <AppButton type='submit' label='Confirm' isSubmitting={isSubmitting} />
                      </Col>
                    </Row>
                  </FormikForm>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
      <div className='text-center mt-3 font-size-14'>
        {resend ? (
          <span className=''>
            Did't receive an otp?{" "}
            <span role='button' className='text-primary' onClick={() => resendMyOtp()}>
              Resend
            </span>
          </span>
        ) : (
          <span className=''>
            OTP code expires in{" "}
            <Badge pill className='badge-soft-primary font-size-15'>
              {counter}
            </Badge>
          </span>
        )}
      </div>
    </div>
  );
};

export default React.memo(VerificationForm);
